import { AfterViewInit, ChangeDetectionStrategy, Component, ElementRef, OnDestroy, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { SessionStorageService } from '@shared/services/storage.service';
import { UserService } from '@shared/services/user.service';
import CO2Controller from './controllers/co2-controller';
import CO2Model from './models/co2-model';
import CO2Service from './services/co2-service';

@Component({
	selector: 'app-co2',
	templateUrl: './view/co2.component.html',
	styleUrls: ['./view/co2.component.scss'],
	changeDetection: ChangeDetectionStrategy.Eager,
	standalone: false,
})
export class CO2Component implements AfterViewInit, OnDestroy {
	@ViewChild('createComponentCO2Dialog')
	createComponentCO2Dialog: ElementRef<HTMLDialogElement>;

	@ViewChild('deleteComponentCO2Dialog')
	deleteComponentCO2Dialog: ElementRef<HTMLDialogElement>;

	@ViewChild('editComponentCO2Dialog')
	editComponentCO2Dialog: ElementRef<HTMLDialogElement>;

	@ViewChild('createComponentCO2LinkDialog')
	createComponentCO2LinkDialog: ElementRef<HTMLDialogElement>;

	@ViewChild('deleteComponentCO2LinkDialog')
	deleteComponentCO2LinkDialog: ElementRef<HTMLDialogElement>;

	@ViewChild('globalErrorDialog')
	globalErrorDialog: ElementRef<HTMLDialogElement>;

	@ViewChild('importCSVDialog')
	importCSVDialog: ElementRef<HTMLDialogElement>;

	@ViewChild('searchComponentCO2LinkDialog')
	searchComponentCO2LinkDialog: ElementRef<HTMLDialogElement>;

	public controller: CO2Controller;
	public model: CO2Model;
	constructor(co2Service: CO2Service, userService: UserService, translateService: TranslateService, sessionStorageService: SessionStorageService) {
		this.model = new CO2Model(translateService);
		this.controller = new CO2Controller(this.model, co2Service, userService, translateService, sessionStorageService);
	}

	public ngAfterViewInit(): void {
		this.controller.createComponentCO2Controller.dialog = this.createComponentCO2Dialog.nativeElement;
		this.controller.deleteComponentCO2Controller.dialog = this.deleteComponentCO2Dialog.nativeElement;
		this.controller.editComponentCO2Controller.dialog = this.editComponentCO2Dialog.nativeElement;
		this.controller.createComponentCO2LinkController.dialog = this.createComponentCO2LinkDialog.nativeElement;
		this.controller.deleteComponentCO2LinkController.dialog = this.deleteComponentCO2LinkDialog.nativeElement;
		this.controller.importCSVController.dialog = this.importCSVDialog.nativeElement;
		this.controller.searchCO2LinkController.dialog = this.searchComponentCO2LinkDialog.nativeElement;
		this.model.globalErrorDialog = this.globalErrorDialog.nativeElement;
	}

	public ngOnDestroy(): void {
		this.controller.destroy();
	}
}
